import React from 'react'
import { Card, Image, Label } from 'semantic-ui-react'

import { useTranslation } from 'react-i18next'
import GridOfContainerTypeInfo from './GridOfContainerTypeInfo'

export default ({ containerTypeInfo }) => {
  const { t: translate } = useTranslation('common')
  return (
    <Card>
      {containerTypeInfo.image && <Image src={containerTypeInfo.image} />}
      <Card.Content>
        <Card.Header>{containerTypeInfo.name}</Card.Header>
        <Card.Meta>
          {`${containerTypeInfo.volumeInGallons} ${translate('Gallons')} | ${containerTypeInfo.volumeInLiters} ${translate('Liters')}`}
        </Card.Meta>

        <Card.Description>
          <GridOfContainerTypeInfo
            info={[
              { label: translate('Height'), measurement: `${containerTypeInfo.heightInInches}"` },
              {
                label: translate('Weight (full)'),
                measurement: `${containerTypeInfo.weightInLbsFull} ${translate('lbs')}`,
              },
              {
                label: translate('Diameter'),
                measurement: `${createDisplayedDiameterText(containerTypeInfo.diameterInInches)}`,
              },
            ]}
          />
        </Card.Description>

        <Card.Description>{translate('Also Known As')}:</Card.Description>
        <Card.Description>
          {containerTypeInfo.alsoKnownAs.map((synonym, index) => {
            return <Label key={`${synonym}-${index}`}>{synonym}</Label>
          })}
        </Card.Description>
      </Card.Content>
    </Card>
  )
}

function createDisplayedDiameterText(diameter) {
  // The diameter value can either be a number or an array of two numbers to
  // indicate a range
  return Array.isArray(diameter) ? `${diameter[0]} - ${diameter[1]}"` : `${diameter}"`
}
